import React from 'react';
import DateTime from 'luxon/src/datetime';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton, DangerButton} from 'Components/Button';

import PollsApi from 'Services/Api/Admin/MainStage/Polls';
import {Toast} from 'Services';

export default class EndPoll extends React.Component {
    /**
     * @var state
     * @type {{working: boolean}}
     */
    state = {
        working: false
    };

    /**
     * @method handleEnd
     * @return {Promise<void>}
     */
    handleEnd = async () => {
        this.setState({working: true});
        const {poll} = this.props;

        let data = {
            ...poll,
            answers: poll.answers.map(a => a.answer),
            display_until: DateTime.now().toUTC().toISO(),
        };

        const request = await PollsApi.patch({
            session: poll.session_id,
            poll: poll.id
        }, data);

        if (request.success) {
            Toast.success('Poll has been ended');
            return this.props.onClose();
        }

        Toast.error();

        this.setState({working: false});
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {working} = this.state;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    End Poll
                </ModalHeader>

                <ModalBody>
                    <p className="text-center">
                        Are you sure you want to end this poll?
                    </p>
                </ModalBody>

                <ModalFooter alignment="center">
                    <PrimaryButton text="Cancel" working={working} onClick={this.props.onClose} className="mr-2" />
                    <DangerButton text="Continue" working={working} onClick={this.handleEnd} />
                </ModalFooter>
            </Modal>
        );
    }
}
